import {
  getSettingValueWithoutAssignment,
  assignSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/getSetting";
import { OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919 } from "@faire/web-api--source/indigofair/settings/OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919";

export const getSettingOptimizedAddToCartDebounce = (): boolean =>
  getSettingValueWithoutAssignment(
    OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919,
    false
  );

export const assignSettinOptimizedAddToCartDebounce = () =>
  assignSetting(OPTIMIZE_ADD_TO_CART_BATCHING_DEBOUNCE_VALUE_240919);
